import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { APIService } from 'src/app/API.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sumit-payment-page',
  templateUrl: './sumit-payment-page.component.html',
  styleUrls: ['./sumit-payment-page.component.css'],
})
export class SumitPaymentPageComponent {
  ogCustomerID: string;
  ogPaymentID: string;
  ogPaymentType: string;
  ogDocumentNumber: string;
  owner: string;
  customerHistoryURL: string;

  constructor(
    private api: APIService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      this.ogCustomerID = params['OGCustomerID'];
      this.ogPaymentID = params['OGPaymentID'];
      this.ogPaymentType = params['OGPaymentType'];
      this.ogDocumentNumber = params['OGDocumentNumber'];
      this.owner = params['owner'];
      if (!this.owner ) {
        const user = await Auth.currentUserInfo();
        this.owner = user.username;
      }
      this.customerHistoryURL = params['customerHistoryURL'];
      let url = `${environment.apiUrl}/updatePaymentOwner?paymentId=${this.ogPaymentID}&owner=${this.owner}`;
      const user = await Auth.currentUserInfo();
      const updatePaymentOwner = this.http.get(url);

      updatePaymentOwner.subscribe((sumitPayment) => {
        console.log('sumitPayment', sumitPayment);
      });
    });
  }
}
